<template>
    <ul class="menu-list">
        <li v-for="(menu) in menuList" :key="menu.id" class="menu-item">
            <div class="menu-item-title" @click="handlePlay(menu)">
                <img v-if="_isAudioElement(menu)" src="../images/icon-audio.png" class="menu-item-title-icon h-44">
                <img v-if="_isVideoElement(menu)" src="../images/icon-video.png" class="menu-item-title-icon">
                <div class="menu-item-title-content">
                    <span class="menu-item-title-text">{{ menu.name }}</span>
                    <span class="menu-item-title-time">{{ menu.bookName }} {{ menu.lessonName }}</span>
                </div>
                <img src="../images/chevron-top.png" class="menu-item-narrow">
            </div>
        </li>
        <PreviewTip v-if="showTip" :tip="tipHtml" @close="showTip = false" />
    </ul>
</template>

<script>
import dayjs from 'dayjs'
import PreviewTip from './preview-tip'
import { PREVIEW_ELEMENT } from '@/constants/preview'

export default {
    name: 'MenuList',
    components: {
        PreviewTip,
    },
    props: {
        menuList: {
            type: Array,
            default: () => [],
        }
    },
    data() {
        return {
            dayjs,
            showTip: false,
            tipHtml: '',
        }
    },
    methods: {
        handlePlay(item) { 
            if (item.hasChildren) {
                this.toAudioPlayer(item)
                return
            }
            if (this._isVideoElement(item)) {
                this.toLearning(item)
                return
            }
            if (this._isAudioElement(item)) {
                this.toLearning(item)
                return
            }
            this.showPreviewTip(item)
        },
        toLearning(item) {
            if (item.url) {
                item = {
                    ...item,
                    recordResource: item.url,
                    recordName: item.name,
                    type: PREVIEW_ELEMENT.AUDIO,
                }
            }
            this.$emit('play', item)
        },
        toAudioPlayer(menuItem) {
            this.$router.push({
                name: 'audioPlayer',
                query: {
                    parentId: menuItem.id,
                },
            })
        },
        showPreviewTip(item) {
            this.showTip = true
            this.tipHtml = item.informDetails
        },
        _isVideoElement(item) {
            return item.videoResource
        },
        _isAudioElement(item) {
            return item.recordResource
        },
    }
}
</script>

<style lang="stylus" scoped>
.menu-list {
    padding: 0;
    margin: 0 auto;
    overflow: auto;
    list-style: none;
}
.menu-item {
    margin-bottom: 16px;
}
.menu-item-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 20px 12px;
    background: #edfafa;
    border-radius: 12px;
    box-shadow: 0px -1px 4px 0px #39a6de inset; 
}
.menu-item-title-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    flex: 1;
}
.menu-item-title-text {
    font-size: 28px;
    font-weight: bold;
    color: #4D4D4D;
}
.menu-item-title-time {
    font-size: 24px;
    line-height: 1;
    color: #2191D2;
}
.menu-item-title-icon {
    width: 52px;
    height: 52px;
    margin-right: 12px;
}
.h-44 {
    height: 44px;
}
.menu-item-narrow {
    width: 34px;
    height: 18px;
    transition: transform 0.3s ease;
    transform: rotate(90deg);
}
.menu-item-num {
    display: flex;
    align-items: center;
    flex-direction: column;
    font-size: 24px;
    font-weight: bold;
    color: #68B800;
}
.menu-item-num-text {
    font-weight: bold;
}

.song-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 0 20px;
    margin: 8px auto;
    list-style: none;
}
.song-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 20px;
    background-color: #4CA9FF;
    border-radius: 12px;
    box-shadow: 0px -1px 4px 0px #4DBEFD inset; 
    color: #fff;
}
.song-item-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    flex: 1;
    margin-right: 40px;
}
.song-item-text {
    font-size: 28px;
    font-weight: bold;
}
.song-item-icon {
    width: 48px;
    height: 48px;
}
.white {
    color: #fff;
}

/* 动画基础样式 */
.slide-enter-active, .slide-leave-active {
    transition: all 0.3s ease;
}
.slide-enter, .slide-leave-to {
    opacity: 0;
}
</style>